import axios from "axios";

export async function getChatMessages(caseId){
    const {data} = await axios.get(`/chat/list/${caseId}`)
    return data
}   

export async function addChatMessage({caseId, messageData}){
    const {data} = await axios.post(`chat/add-message/${caseId}`,messageData)
    return data
}  

export async function addFileMessage(caseId, userId, formData){
    const config ={
        headers: {
            'Content-Type': 'multipart/form-data',
          },
        data: formData,
    }
    const {data} = await axios.post(`chat/add-file/${caseId}`,formData,config)
    return data
}  

export async function sendEmail({lawsuit_number, link}){
    const body = {lawsuit_number, link}
    const {data} = axios.post('chat/email-notification',body)
    return data
}

export async function getFileData(fileId){
    const {data} = await axios.get(`chat/download-file/${fileId}`)
    return data
}  
